export const SET_ACTIVE_PANEL_TABS = 'SET_ACTIVE_PANEL_TABS';
export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';
export const SET_METRIC_DATA = 'SET_METRIC_DATA';
export const SET_METRIC_DATA_LOADING = 'SET_METRIC_DATA_LOADING';
export const SET_VIEW_STATE_LOADING = 'SET_VIEW_STATE_LOADING';
export const SET_VIEW = 'SET_VIEW';
export const SET_WIDGET_FILTERS = 'SET_WIDGET_FILTERS';
export const SET_LOADING_PANEL = 'SET_LOADING_PANEL';
